export enum CannabinoidDisplayType {
  Exact = 'exact',
  Range = 'range'
}
